import { Helmet } from "react-helmet-async"
import { ErrorView } from "shared/ui/errorView"
import React from "react"

// ----------------------------------------------------------------------

export function Page403(): React.JSX.Element {
  return (
    <>
      <Helmet>
        <title>403 - отказано в доступе</title>
      </Helmet>

      <ErrorView
        label="403"
        title="Доступ запрещен"
        description="Вы пытаетесь попасть на страницу, к которой у вас нет доступа. Если вы считаете, что произошла ошибка,
        пожалуйста, свяжитесь с администрацией."
      />
    </>
  )
}
